import { useNavigate } from 'react-router-dom';
import { authFetch } from '../../../utils/authHelpers';
import ProjectActivityFeed from '../ProjectActivityFeed';
import PortalMessagesPanel from '../PortalMessagesPanel';
import { useProjectData } from '../ProjectDataContext';

function ActivityPanel({ onOpenTab }) {
  const navigate = useNavigate();
  const {
    userEmail,
    project,
    tasks,
    deliverables,
    notes,
    transcripts,
    draaidagen,
    callsheets,
  } = useProjectData();

  return (
    <>
        <ProjectActivityFeed
          notes={notes}
          transcripts={transcripts}
          tasks={tasks}
          deliverables={deliverables}
          draaidagen={draaidagen}
          callsheets={callsheets}
          onNavigate={(item) => {
            // Navigate to the appropriate tab or open detail
            const tabMap = { task: 'taken', deliverable: 'deliverables', shoot_day: 'draaidagen', callsheet: 'callsheets', note: 'notes', meeting: 'meetings', frameio: 'frameio' };
            const targetTab = tabMap[item.type];
            if (item.type === 'meeting' && item.meta?.meetingId) {
              navigate(`/MeetingDashboard/${item.meta.meetingId}`);
            } else if (targetTab !== undefined) {
              onOpenTab(targetTab);
            }
          }}
        />
        <PortalMessagesPanel
          projectId={project?.airtable_id || project?.id}
          currentUserEmail={userEmail}
          authFetch={authFetch}
        />
    </>
  );
}

export default ActivityPanel;
